import React from "react";
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

const SelectContainer = ({ config, onChange }) => {
  return (
    <div className={config.classContainer}>
      <Label {...config} />
      <div className="div-select-form">
        <select className={config.classInput} onChange={(e) => onChange(config.variable, e.target.value, config.type)}>
          {
            (config.placeholder !== undefined && config.placeholder !== null && config.placeholder !== '') &&
            <option value="" selected={(config.value === undefined || config.value === null || config.value === "")}>{config.placeholder}</option>
          }
          {
            config.data.map((item, index) => {
              return (
                <option
                  value={item[config.keyValue]}
                  key={`sfk-${item.variable}-${index}`}
                  selected={item[config.keyValue] === config.value}
                  disabled={item.disabled}
                >
                  {item[config.keyText]}
                </option>
              )
            })
          }
        </select>
      </div>
      {
        <Required {...config} msg="Seleccione al menos un elemento" />
      }
    </div >
  )
}

export default SelectContainer;
